import React from 'react';
import { PageLayout } from '@voilajsx/uikit/page';
import { Header, Footer, SEO } from '../../../shared/components';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';

const APP_NAME = import.meta.env.VITE_APP_NAME === 'plotmagic' ? 'PlotMagic' : 'RRD Planners';
const LEGAL_NAME = 'RRD Planners and Constructions';
const ADDRESS = 'Sathya Sai Nagar, Naidupump, Warangal, Telangana, India';
const EMAIL = 'rrdplanners@gmail.com';
const PHONE = '+91 7989358436';
const WHATSAPP = 'https://wa.me/917989358436';

const ContactPage: React.FC = () => {
  return (
    <PageLayout size="full">
      <SEO title={`Contact Us - ${APP_NAME}`} description="Get in touch with us" />
      <Header />
      <PageLayout.Content>
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="space-y-8">
            <div className="text-center space-y-4">
              <h1 className="text-4xl font-bold text-foreground">Contact Us</h1>
              <p className="text-muted-foreground">We'd love to hear from you. Reach out to us through any of the channels below.</p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 20 }}>
              <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: 24, textAlign: 'center' }}>
                <div style={{ width: 48, height: 48, background: 'rgba(255,217,61,0.1)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                  <Mail size={22} style={{ color: '#FFD93D' }} />
                </div>
                <h3 style={{ color: '#e5e5e5', fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Email</h3>
                <a href={`mailto:${EMAIL}`} style={{ color: '#FFD93D', fontSize: 14, textDecoration: 'none' }}>{EMAIL}</a>
              </div>

              <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: 24, textAlign: 'center' }}>
                <div style={{ width: 48, height: 48, background: 'rgba(255,217,61,0.1)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                  <Phone size={22} style={{ color: '#FFD93D' }} />
                </div>
                <h3 style={{ color: '#e5e5e5', fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Phone</h3>
                <a href={`tel:${PHONE}`} style={{ color: '#FFD93D', fontSize: 14, textDecoration: 'none' }}>{PHONE}</a>
              </div>

              <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: 24, textAlign: 'center' }}>
                <div style={{ width: 48, height: 48, background: 'rgba(255,217,61,0.1)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                  <MessageCircle size={22} style={{ color: '#FFD93D' }} />
                </div>
                <h3 style={{ color: '#e5e5e5', fontSize: 16, fontWeight: 600, marginBottom: 8 }}>WhatsApp</h3>
                <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" style={{ color: '#FFD93D', fontSize: 14, textDecoration: 'none' }}>Chat with us</a>
              </div>

              <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: 24, textAlign: 'center' }}>
                <div style={{ width: 48, height: 48, background: 'rgba(255,217,61,0.1)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                  <MapPin size={22} style={{ color: '#FFD93D' }} />
                </div>
                <h3 style={{ color: '#e5e5e5', fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Address</h3>
                <p style={{ color: '#888', fontSize: 14, lineHeight: 1.6 }}>{ADDRESS}</p>
              </div>
            </div>

            <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: 32, marginTop: 20 }}>
              <h2 style={{ color: '#e5e5e5', fontSize: 20, fontWeight: 600, marginBottom: 16 }}>Business Details</h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '10px 20px', color: '#888', fontSize: 14 }}>
                <span style={{ color: '#666' }}>Legal Name</span><span style={{ color: '#ccc' }}>{LEGAL_NAME}</span>
                <span style={{ color: '#666' }}>Address</span><span style={{ color: '#ccc' }}>{ADDRESS}</span>
                <span style={{ color: '#666' }}>Email</span><span style={{ color: '#ccc' }}>{EMAIL}</span>
                <span style={{ color: '#666' }}>Phone</span><span style={{ color: '#ccc' }}>{PHONE}</span>
                <span style={{ color: '#666' }}>Business Hours</span><span style={{ color: '#ccc' }}>Mon - Sat, 9:00 AM - 7:00 PM IST</span>
              </div>
            </div>

            <div className="text-center pt-8 border-t border-border">
              <a href="/" className="inline-flex items-center text-primary hover:underline font-medium">← Back to Home</a>
            </div>
          </div>
        </div>
      </PageLayout.Content>
      <Footer />
    </PageLayout>
  );
};

export default ContactPage;
